<template>
    <div v-if="hasModule('REMManagement')">
        <list-container :header="translate('incomingChannel.incomingDocTargets')" v-show="!$route.params.id" :showSearch="true" @search="searchUser">
            <template v-slot:commands>
                <button type="button" class="btn btn-primary" @click="$router.push({ name: 'IncomingChannelDetail',  params: { id: '000000000000000000000000' }, })">
                    {{translate('incomingChannel.newIncomingDocTarget')}}
                </button>
            </template>
            <list ref="channelList" :columns="columns" url="/incomingChannel/get" modelName="IncomingChannel" orderBy="IsActive desc, name"> </list>
        </list-container>
        <router-view v-if="$route.params.id"/>
    </div>
    <div v-else class="alert alert-danger">
        {{translate('errors.notAuthorizedForTheProcess')}}
    </div>
</template>

<script>
import list from "../components/List.vue";
import listContainer from "../components/ListContainer.vue";
import Vue from "vue";
export default {
    data() {
        return {
            searchText: "",
            // predicate: "IsServiceUser != true",
            channelList: [],
            columns: [
                {
                    Key: "name",
                    Title: this.translate('externalSigner.name'),
                    SortField: "name",
                },
                {
                    Key: "type",
                    Title: this.translate('categoryList.columns.type'),
                },
                
                {
                    Key: "isActive",
                    Title: this.translate('categoryList.columns.active'),
                    SortField: "isActive",
                    Class: "text-center",
                    Content(i) {
                        return Vue.filter('checkicon')(i.isActive);
                    }
                },
                {
                    Key: "archiveType",
                    Title: this.translate('incomingChannel.archiveKind'),
                    Content(i) {
                        return Vue.filter('archiveType')(i.archiveType);
                    }
                },
                
            ],
        };
    },
    components: {
        list,
        listContainer,
    },
    methods:{ 
        searchUser(text) {
            // var parts = [];
            // console.log(text);
            
            // if(text != "")
            //     parts.push(`FirstName.ToLower().Contains("${text.toLowerCase()}") || LastName.ToLower().Contains("${text.toLowerCase()}")`);

            // this.predicate = parts.join(" && "); 
            // this.$refs.channelList.predicate = this.predicate;
            // this.$refs.channelList.getData();

            this.$refs.channelList.page = 1;
            this.$refs.channelList.filter = { search: text };
            this.$refs.channelList.getData();
        },
    }
            
};
</script>
<style scoped>
    .col-search {
        margin-top: 20px;
        float: right;
        clear: both;
        width: 39%;
    }
    .mbm {
        margin-bottom: 10px !important;
    }
    .input-group-btn {
        padding-left: 10px;
        padding-top: 6px;
        padding-right: 10px;
        background-color: #e5e5e5;
        color: #777777;
        border-color: #e5e5e5;
        border: 1px solid #e5e5e5;
        position: relative;
        font-size: 0;
        white-space: nowrap;
    }
</style>
